// extracted by mini-css-extract-plugin
module.exports = {"waterfall":"_5977","noCompleteTips":"_16365","center":"_19027"};